import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import PracticeAreas from './components/PracticeAreas';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import MidPageCTA from './components/MidPageCTA';
import FinalCTA from './components/FinalCTA';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="w-full overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <PracticeAreas />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <MidPageCTA />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <LeadForm />
      <Footer />
    </main>
  );
}
